import PatientList from '../patient/PatientList.tsx';

const Patients = () => {
  return <PatientList />;
};
export default Patients;
